import React from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { EntityAuditHistoryTestIds } from '../../EntityAuditHistory.testIds';

/** A panel's count next to its title: fixed `text`, or what its `renderer` makes of the changes. */
const AuditPanelSubtitle = ({
  text = null,
  renderer: SubtitleRenderer = null,
  changes,
  detail,
}) => (
  <Typography
    color="text.secondary"
    component="span"
    data-testid={EntityAuditHistoryTestIds.CHANGES_PANEL_SUBTITLE}
    variant="regular12"
  >
    {SubtitleRenderer ? <SubtitleRenderer changes={changes} detail={detail} /> : text}
  </Typography>
);

AuditPanelSubtitle.propTypes = {
  changes: PropTypes.arrayOf(PropTypes.object).isRequired,
  detail: PropTypes.object.isRequired,
  text: PropTypes.string,
  renderer: PropTypes.elementType,
};

export default AuditPanelSubtitle;
